/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_SkipInputs */

const cs_pm_skip = /** @type {(inputs: Pm_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeskočit`)
};

const en_pm_skip = /** @type {(inputs: Pm_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip`)
};

/**
* | output |
* | --- |
* | "Skip" |
*
* @param {Pm_SkipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_skip = /** @type {((inputs?: Pm_SkipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_SkipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_skip(inputs)
	return cs_pm_skip(inputs)
});